import { GRAY_COLORS, BRAND_COLORS, ERROR_COLORS } from '../globalTheme';

export function getSelectStyles() {
	return {
		containerCss: {
			display: 'flex',
			flexDirection: 'column',
			gap: '8px'
		},
		selectCss: {
			border: 'none' as const,
			outline: 'none' as const,
			backgroundColor: 'transparent',
			background: 'transparent',
			flexGrow: 1,
			appearance: 'none' as const
		},
		selectContainerCss: {
			display: 'flex',
			alignItems: 'center',
			padding: '10px 14px',
			height: '30px',
			borderRadius: 8
		},
		selectBorder: {
			border: `1px solid ${GRAY_COLORS.gray300}`
		},
		errorBorder: {
			border: `1px solid ${ERROR_COLORS.error300}`
		},
		selectContainerPillCss: {
			borderRadius: 999
		},
		focusedSelectContainerCss: {
			border: `1px solid ${BRAND_COLORS.brand300}`,
			boxShadow: `0px 0px 0px 4px ${BRAND_COLORS.brand100}`
		},
		disabledSelectContainerCss: {
			background: GRAY_COLORS.gray50,
			cursor: 'not-allowed'
		},
		inputLabel: {
			color: GRAY_COLORS.gray700
		},
		loadingIconCss: {
			color: BRAND_COLORS.brand300
		},
		errorMessage: {
			fontSize: '14px',
			color: ERROR_COLORS.error500
		}
	};
}
